module.exports = __webpack_public_path__ + "static/media/account-setting.acb45224.svg";